export const assessments = {
  week1: {
    title: "Assessment",
    subtitle: "Let's test your knowledge on Emotional Regulation",
    questions: [
      {
        id: 1,
        question: `What does the term "regulation" mean?`,
        options: [
          { id: "A", text: "Following the rules in a game." },
          { id: "B", text: "Controlling or managing your emotions and behavior." },
          { id: "C", text: "Ignoring your feelings." },
          { id: "D", text: "Always being happy." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Which of the following emotions would belong to the Blue Zone?",
        options: [
          { id: "A", text: "Joy." },
          { id: "B", text: "Sadness." },
          { id: "C", text: "Excitement." },
          { id: "D", text: "Anger." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "What is the Green Zone known for?",
        options: [
          { id: "A", text: "Feeling tired and bored." },
          { id: "B", text: "Being calm, happy, and ready to learn." },
          { id: "C", text: "Feeling silly or anxious." },
          { id: "D", text: "Experiencing big, uncontrollable emotions." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "If someone is feeling excited or a little nervous, which zone are they likely in?",
        options: [
          { id: "A", text: "Blue Zone." },
          { id: "B", text: "Green Zone." },
          { id: "C", text: "Yellow Zone." },
          { id: "D", text: "Red Zone." },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question: "What is the main characteristic of the Red Zone?",
        options: [
          { id: "A", text: "Being calm and focused." },
          { id: "B", text: "Experiencing small emotions." },
          { id: "C", text: "Having very big and strong emotions." },
          { id: "D", text: "Feeling balanced and happy." },
        ],
        correctOption: "C",
      },
    ]

  },
  week2: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "How many energy levels are represented by the Zones of Regulation?",
        options: [
          { id: "A", text: "Two." },
          { id: "B", text: "Three." },
          { id: "C", text: "Four." },
          { id: "D", text: "Five." },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question:
          "Which zone represents low energy levels, like feeling tired or sad?",
        options: [
          { id: "A", text: "Yellow Zone." },
          { id: "B", text: "Red Zone." },
          { id: "C", text: "Blue Zone." },
          { id: "D", text: "Green Zone." },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question:
          "Which zone represents balanced energy, where you feel calm and ready to learn?",
        options: [
          { id: "A", text: "Blue Zone." },
          { id: "B", text: "Green Zone." },
          { id: "C", text: "Yellow Zone." },
          { id: "D", text: "Red Zone." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "Which zone represents higher energy levels where you might feel excited but still in control?",
        options: [
          { id: "A", text: "Blue Zone." },
          { id: "B", text: "Yellow Zone." },
          { id: "C", text: "Green Zone." },
          { id: "D", text: "Red Zone." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Which zone represents the highest energy levels, where you might feel overwhelmed or out of control?",
        options: [
          { id: "A", text: "Yellow Zone." },
          { id: "B", text: "Green Zone." },
          { id: "C", text: "Red Zone." },
          { id: "D", text: "Blue Zone." },
        ],
        correctOption: "C",
      },
    ]
  },
  week3: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What does the 'S' in the SONAR method stand for?",
        options: [
          { id: "A", text: "Start talking." },
          { id: "B", text: "Stop when you notice big emotions." },
          { id: "C", text: "Stay calm." },
          { id: "D", text: "Smile through your feelings." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which step of the SONAR method encourages you to give a name to what you are feeling?",
        options: [
          { id: "A", text: "Observe." },
          { id: "B", text: "Name it." },
          { id: "C", text: "Accept." },
          { id: "D", text: "Regulate." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "What is the purpose of the 'A' in the SONAR method?",
        options: [
          { id: "A", text: "Avoid your emotions." },
          { id: "B", text: "Act on your feelings." },
          { id: "C", text: "Accept what you are feeling." },
          { id: "D", text: "Analyze the situation." },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question: "Which of the following is NOT a part of the SONAR method?",
        options: [
          { id: "A", text: "Observe." },
          { id: "B", text: "Name." },
          { id: "C", text: "Analyze." },
          { id: "D", text: "Regulate." },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question: "Why is the SONAR method important?",
        options: [
          { id: "A", text: "It helps us ignore our emotions." },
          {
            id: "B",
            text: "It teaches us to control and understand our emotions better.",
          },
          { id: "C", text: "It stops us from feeling emotions." },
          { id: "D", text: "It makes our emotions disappear completely." },
        ],
        correctOption: "B",
      },
    ]
  },
  week4: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What are coping skills?",
        options: [
          { id: "A", text: "Strategies to avoid emotions." },
          { id: "B", text: "Tools to help manage emotions and challenges." },
          { id: "C", text: "Rules for controlling others’ feelings." },
          { id: "D", text: "Exercises to increase physical strength." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Which of these is an example of a physical coping skill?",
        options: [
          { id: "A", text: "Writing in a journal." },
          { id: "B", text: "Taking a deep breath." },
          { id: "C", text: "Talking to a friend." },
          { id: "D", text: "Listening to music." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "What type of coping skill involves expressing yourself through creativity?",
        options: [
          { id: "A", text: "Physical coping skill." },
          { id: "B", text: "Emotional coping skill." },
          { id: "C", text: "Creative coping skill." },
          { id: "D", text: "Relaxation coping skill." },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question: "Why is it important to have different types of coping skills?",
        options: [
          { id: "A", text: "So you can teach them to others." },
          { id: "B", text: "Because what works for one person may not work for another." },
          { id: "C", text: "To help you avoid all emotions." },
          { id: "D", text: "To make sure you are always happy." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question: "Which of the following is NOT a healthy coping skill?",
        options: [
          { id: "A", text: "Yelling at someone when you’re upset." },
          { id: "B", text: "Drawing to express your feelings." },
          { id: "C", text: "Taking a walk to calm down." },
          { id: "D", text: "Talking to someone you trust." },
        ],
        correctOption: "A",
      },
    ]
  },
  week5: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "You just failed a test that you studied really hard for, and now you feel like giving up. What is the best way to handle this situation?",
        options: [
          { id: "A", text: "Ignore how you feel and move on." },
          { id: "B", text: "Control and manage your emotions." },
          { id: "C", text: "Hide your emotions from others." },
          { id: "D", text: "Let your emotions control you." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "During class, you feel calm and focused on the lesson. Which zone of regulation are you in?",
        options: [
          { id: "A", text: "Red Zone." },
          { id: "B", text: "Yellow Zone." },
          { id: "C", text: "Green Zone." },
          { id: "D", text: "Blue Zone." },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question:
          "You’re really angry after a disagreement with your friend, and you feel like yelling. What is the first step in the SONAR method to help you calm down?",
        options: [
          { id: "A", text: "Accept what you are feeling." },
          { id: "B", text: "Stop when you notice the big emotions." },
          { id: "C", text: "Name your emotion." },
          { id: "D", text: "Observe the feelings in your body." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "Your team just lost an important game, and you feel sad and frustrated. What can coping skills help you do?",
        options: [
          { id: "A", text: "Ignore your emotions." },
          { id: "B", text: "Regulate your emotions effectively." },
          { id: "C", text: "Always feel happy." },
          { id: "D", text: "Avoid dealing with your feelings." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "You’re so upset that you want to throw your backpack across the room. Which of these is a better way to handle your emotions?",
        options: [
          { id: "A", text: "Taking a break." },
          { id: "B", text: "Throwing things." },
          { id: "C", text: "Deep breathing." },
          { id: "D", text: "Talking to a trusted adult." },
        ],
        correctOption: "A",
      },
      {
        id: 6,
        question:
          "You are so excited about winning a competition that you can’t sit still in class. Which zone of regulation are you in?",
        options: [
          { id: "A", text: "Red Zone." },
          { id: "B", text: "Yellow Zone." },
          { id: "C", text: "Blue Zone." },
          { id: "D", text: "Green Zone." },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question:
          "Your heart is racing, and your hands are sweaty before giving a big presentation. What is the purpose of naming your emotions in the SONAR method?",
        options: [
          { id: "A", text: "To distract yourself." },
          { id: "B", text: "To blame others for how you feel." },
          { id: "C", text: "To understand what you are feeling." },
          { id: "D", text: "To ignore the emotion." },
        ],
        correctOption: "C",
      },
      {
        id: 8,
        question:
          "You’re feeling tired and unmotivated after staying up late playing video games. Which zone are you in, and how might you feel?",
        options: [
          { id: "A", text: "Green Zone, calm and happy." },
          { id: "B", text: "Blue Zone, sad and low energy." },
          { id: "C", text: "Red Zone, angry and out of control." },
          { id: "D", text: "Yellow Zone, frustrated and silly." },
        ],
        correctOption: "B",
      },
      {
        id: 9,
        question:
          "You’re starting to lose focus while doing homework, but you don’t want to get distracted. Which coping skill might help you stay on task?",
        options: [
          { id: "A", text: "Listening to loud music." },
          { id: "B", text: "Writing in a journal." },
          { id: "C", text: "Doing a quick stretch." },
          { id: "D", text: "Counting to 10." },
        ],
        correctOption: "C",
      },
      {
        id: 10,
        question:
          'Before an exam, you feel a knot in your stomach and your breathing quickens. What does "observe the feelings in your body" mean in the SONAR method?',
        options: [
          { id: "A", text: "Pay attention to how your body reacts to emotions." },
          { id: "B", text: "Ignore physical sensations and focus on your thoughts." },
          { id: "C", text: "Blame your body for how you feel." },
          { id: "D", text: "Control all physical movements." },
        ],
        correctOption: "A",
      },
    ] 
  },
};
